import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  requiredPeriodText: {
    id: "funding-application: air revenue source required",
    defaultMessage: "{dateFrom} to {dateTo}",
  },
  platformsAccordionTitle: {
    id: "funding-application: air revenue source connected platforms accordion title",
    defaultMessage: "View your connected eCommerce platforms",
  },
  canYouConnectAnother: {
    id: "funding-application: air revenue source can you connect another",
    defaultMessage: "Can you connect another eCommerce platform?",
  },
  cannotConnectAnotherOption: {
    id: "funding-application: air revenue source cannot connect another",
    defaultMessage: "No, I am unable to connect another eCommerce platform",
  },
  canConnectAnotherOption: {
    id: "funding-application: air revenue source can connect another account",
    defaultMessage: "Yes, I can connect another eCommerce account",
  },
  faqWhyDoYouNeedMyDataQuestion: {
    id: "funding-application: air revenue source why do you need my data",
    defaultMessage: "Why do you need my eCommerce data?",
  },
  faqWhyDoYouNeedMyDataAnswer: {
    id: "funding-application: air revenue source why do you need my data answer",
    defaultMessage:
      "Your eCommerce data gives us important information about your revenue and order patterns, and insights into how your business is likely to grow. This helps us determine how much financing we can offer. The total remittance amount for the financing will be based on all of your connected eCommerce sources.",
  },
  lessThan180DaysCompanyOption: {
    id: "funding-application: air revenue source less than 6 months company option",
    defaultMessage: "My eCommerce company is less than 6 months old",
  },
  previousCompantDecommissionedOption: {
    id: "funding-application: air revenue source previous company decommissioned option",
    defaultMessage: "My previous eCommerce company has been decommissioned",
  },
  noOtherPlatformsLabel: {
    id: "funding-application: air revenue source no other platforms label",
    defaultMessage: "Please select a reason",
  },
  noOtherPlatformsOption: {
    id: "funding-application: air revenue source no other platforms option",
    defaultMessage: "I don’t have other eCommerce platforms",
  },
  otherReasonOption: {
    id: "funding-application: air revenue source other reason option",
    defaultMessage: "Other",
  },
  pleaseSpecifyReason: {
    id: "funding-application: air revenue source please specify reason",
    defaultMessage: "Please specify",
  },
  pleaseSelectAnOptionError: {
    id: "funding-application: air revenue source please select an option error",
    defaultMessage: "Please select an option",
  },
  pleaseSpecifyReasonError: {
    id: "funding-application: air revenue source please specify reason error",
    defaultMessage: "Please specify a reason",
  },
  selectRevenuePlatformDescription: {
    id: "funding-application: select revenue platform description",
    defaultMessage: "Select the eCommerce platform you would like to connect",
  },
  selectRevenuePlatformError: {
    id: "funding-application: add additional revenue platform error",
    defaultMessage: "Please select an additional platform",
  },
  periodMonths: {
    id: "funding-application: air revenue source period months",
    defaultMessage: "{period, plural, =1 {# month} other {# months}}",
  },
  periodWeeks: {
    id: "funding-application: air revenue source period weeks",
    defaultMessage: "{period, plural, =1 {# week} other {# weeks}}",
  },
});
